<template>
  <!--  https://chenxuan0000.github.io/vue-seamless-scroll/zh/guide/-->
  <div class="llyyBox">
    <div class="llyy_left_i llyy_i" @click="leftYY" :style="{ backgroundColor: colorData.left }">
      <div class="circle-container">
        <i class="el-icon-arrow-left"></i>
      </div>
    </div>
    <div class="llyy_ze">
      <div class="llyyHeader">
        <div class="llyy_left">临床应用</div>
        <div class="llyy_right" @click="llyyCK">
          <div class="llyy_text_dd_1">查看更多</div>
          <div ><i class="el-icon-right"></i></div>
        </div>
      </div>
      <div class="llyyContentBox">
        <div class="llyy_item"  v-show="item.showData" v-for="item in llyyItem">
          <div class="llyy_item_img">
            <div class="llyy_item_img_1" :style="{backgroundImage:'Url('+item.imgUrl+')'}">
              <div class="llyy_item_img_xx">
                <div class="llyy_item_img_p1">
                  {{item.text1}}
                </div>
                <div class="llyy_item_img_p2">
                  {{item.text2}}
                </div>
                <div class="llyy_item_img_p3" @click="lcyyTo(item.index)">
                 了解更多
                </div>
              </div>
            </div>
<!--            <el-image class="ttyy"-->
<!--              style="width: 1176px; height: 488px"-->
<!--              :src="item.imgUrl"-->
<!--              :fit="contain"></el-image>-->
          </div>

        </div>
      </div>
    </div>
    <div class="llyy_right_i" @click="rightYY" :style="{ backgroundColor: colorData.right }">
      <i class="el-icon-arrow-right llyy_i"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "llyy",
  data() {
    return {
      indexUrl: 1,
      colorData:{
        right:"#5daf34",
        left:"#666666"
      },
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        limitMoveNum: 2,
        switchSingleStep: 428,
        direction: 2,
        // autoPlay:false,
        navigation:true
      },
      llyyItem:[
        {
          index:1,
          text1:"牙周疾病治疗",
          text2:"牙周清创，辅助龈下刮治和根面平整，牙龈切除或修整，牙龈瘤切除，牙周翻瓣手术，闭合式冠延长术",
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/lcyy1.jpg"},
        {
          index:2,
          text1:"儿童牙病治疗",
          text2:"窝沟封闭，牙髓凝固，活髓切断，切开助萌",
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/lcyy2.jpg",
           }
        //    ,
        // {
        //   index:3,
        //   showData:true,
        //   imgUrl:"https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
        //      },
        // {
        //   index:4,
        //   showData:false,
        //   imgUrl:"https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg",
        //    },
        // {
        //   index:5,
        //   showData:false,
        //   imgUrl:"https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg",
        //          }
      ]
    }
  },
  created() {
    let that = this;
    console.log(that.urlData);
    that.indexUrl = that.$route.query.index;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    that.init();

  },
  methods:{
    init(){
      let that = this;
      if(that.indexUrl != '' && that.indexUrl != undefined) {

          for (var i = 0; i < that.llyyItem.length; i++) {
            let item = that.llyyItem[i];
            if(i == that.indexUrl-1){
              item.showData = true;
            } else {
              item.showData = false;
            }
          }

        if(that.indexUrl > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#666666'
        }
        if(that.cpjsItem.length >= that.indexUrl){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#666666'
        }

      } else {
        that.indexUrl = 1;
        for (var i = 0; i < that.llyyItem.length; i++) {
          let item = that.llyyItem[i];
          if(i == that.indexUrl-1){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }

        that.colorData.left = '#666666'

        if(that.llyyItem.length > 1){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#666666'
        }
      }
      console.log(that.indexUrl)
    },
    leftYY(){
      console.log("left")
      let that = this;
      if(that.indexUrl === 1){
        return;
      } else {
        let indexBB = that.indexUrl-1;
        for (var i = 0; i < that.llyyItem.length; i++) {
          let item = that.llyyItem[i];
          if(i ==(indexBB-1) ){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#666666'
        }
        if(that.llyyItem.length > indexBB-1){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#666666'
        }
        that.indexUrl = indexBB;
      }

    },
    rightYY(){
      console.log("right")
      let that = this;
      if(that.indexUrl == that.llyyItem.length){
        return;
      } else {
        console.log(that.indexUrl)
        let indexBB = that.indexUrl+1;
        for (var i = 0; i < that.llyyItem.length; i++) {
          let item = that.llyyItem[i];
          console.log(item)
          console.log(i)
          console.log(indexBB)
          if(i==(indexBB-1) ){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#666666'
        }
        if(that.llyyItem.length > indexBB){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#666666'
        }
        that.indexUrl = indexBB;
      }
    },
    llyyCK(){
      this.$router.push('/clinical');
    },
    lcyyTo(path){
      this.$router.push('/clinical?path='+path);
    }
  }
}
</script>

<style lang="scss" scoped>
.llyy_item_img_xx{
  margin-left: 50px;
}
.llyy_item_img_p3_1{
  background-color: #5daf34;
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.llyy_item_img_p3{
  width: 176px;
  height: 50px;
  background-color: #5daf34;
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.llyy_item_img_p1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #FFFFFF;
  letter-spacing: 0.77px;
  text-align: justify;
  margin-bottom: 30px;
}
.llyy_item_img_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
  margin-bottom: 60px;
}
.llyy_item_img_1{
  width: 1176px;
  height: 484px;
  display: flex;
  align-items: center;
}
.ttyy{
  border-radius: 10px;
}
.llyy_text_dd_1{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.llyy_right_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 200px;
  cursor: pointer;
}
.llyy_left_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #FFFFFF; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 200px;
  cursor: pointer;
}
.llyyContentBox{
  display: flex;
}
.llyy_item_text1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0.51px;
  text-align: justify;
  margin-top: 30px;
  margin-right: 30px;
  margin-left: 30px;

}
.llyy_item_text2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
  margin-top: 30px;

  margin-right: 30px;
  margin-left: 30px;
}
.llyy_item{
}

.llyyBox{
  width: 1920px;
  margin: 0 auto;
  padding: 100px 0px;
  //background-image: url("https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg");
  background-size:100% 100%;
  display: flex;
  align-items: center;
}
.llyy_ze{
  width: 1176px;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.llyyHeader{
  width: 1176px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.llyy_left{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0.64px;
  text-align: justify;
}
.llyy_right{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #8c939d;
  letter-spacing: 0;
  text-align: justify;
  display: flex;
  cursor: pointer;
}

.warp {
  width: 402px*3-26;
  height: 576px;
  margin: 0 auto;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;

      .li-item {
        width: 376px;
        height: 576px;
        margin-right: 26px;
        line-height: 576px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/image/llyy.vue